export type CommonwealthGamesUrlColorMode = 'light' | 'dark'

export function resolveCommonwealthGamesWidgetColorMode(
    colorMode?: CommonwealthGamesUrlColorMode,
): CommonwealthGamesUrlColorMode | undefined {
    if (colorMode) {
        return colorMode
    }

    if (typeof window === 'undefined') {
        return undefined
    }

    const searchParams = new URLSearchParams(window.location.search)

    // Fallback for older app clients that may not yet pass colorMode=dark.
    if (searchParams.get('dark') === 'true') {
        return 'dark'
    }

    const urlColorMode = searchParams.get('colorMode')
    return urlColorMode === 'dark' || urlColorMode === 'light'
        ? urlColorMode
        : undefined
}
